<template lang="pug">
div
  section.u-mt-md
    AppTitle.u-mb-xm(:title="$t('mantra')")
    .grid.is-widescreen-8.is-desktop-10
      .column
        p.u-text-lg {{$t('mantraDesc')}}

  section.u-mt-md
    .grid
      .column.is-widescreen-5
        AppTitle.u-mb-mi(:title="$t('sec1')" tag="h2")
      .column.is-widescreen-7
        .grid.is-tablet-6
          .column.u-mb-sm(v-for="item,idx in $t('sec1Items')")
            h5 {{item}}


  section.u-mt-md
    .grid
      .column.is-widescreen-5
        AppTitle.u-mb-mi(:title="$t('sec2')" tag="h2")
      .column.is-widescreen-7
        .grid.is-tablet-6
          .column.u-mb-sm(v-for="item,idx in $t('sec2Items')")
            h4 {{item.title}}
            p {{item.desc}}

  section.u-mt-md.u-mb-md
    AppLink(to="/contact" :title="$t('cta')" class="button-link is-large " v-html="$t('cta')")

</template>

<script>
export default {
  head() {
    const $t = this.$t.bind(this);
    return {
      title: $t('pageTitle'),
      meta: [
        {
          hid: 'og:title',
          name: 'og:title',
          property: 'og:title',
          content: $t('pageTitle')
        },
        {
          hid: 'description',
          name: 'description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:description',
          name: 'og:description',
          property: 'og:description',
          content: $t('pageDesc')
        }
      ]
    };
  }
};
</script>

<i18n>
{
  "en": {
    "pageTitle":"Design talks",
    "pageDesc":"Design talks is Baianat event for designers from different fields where they can share experience and let go of their creative skills.",
    "mantra":"Surpass your |creativity limits.",
    "mantraDesc":"Design talks is where Baianat design team meets the community of designers from various fields for a day full of insightful conversations, real projects case studies and practical tips from inside every industry.",
    "sec1":"Why attend Design talks?",
    "sec1Items":{
      "1":"Meeting cool designers from different fields, schools and backgrounds and getting a glimpse on their techniques and portfolios.",
      "2":"Networking for future project collaborations and making friends from a like minded community that shares your interests.",
      "3":"Meeting Baianat on ground and getting a sneak peek into what’s happening behind the scenes and how our thinking process emerges these projects."
    },
    "sec2":"We got you in the riddle of creativity!",
    "sec2Items":{
      "1":{
        "title":"Branding",
        "desc":"From strategy to identity development, we share with you in depth details and field hacks that worked for us internally. "
      },
      "2":{
        "title":"User experience",
        "desc":"Giving out tips for an easy user experience"
      },
      "3":{
        "title":"3D production",
        "desc":"Whether in product design, advertising or animation, we dive deep with you in the art of 3D."
      },
      "4":{
        "title":"Advertising",
        "desc":"From campaign creation to user behavior, we give you insights from our journey in the advertising world. "
      }
    },
    "cta":"Join our <br> design talks!"
  },
  "ar": {
    "pageTitle":"مناقشات التصميم",
    "pageDesc":"مناقشات التصميم هي أحد فعاليات بيانات للمصممين من مختلف المجالات حيث يمكنهم تبادل الخبرات وزيادة مهاراتهم الإبداعية.",
    "mantra":"تخطى جميع الحدود |وزود مهاراتك الإبداعية.",
    "mantraDesc":"مناقشات التصميم هي الفعالية التي يجتمع فيها فريق تصميم بيانات مع مجموعة من المصممين من مختلف المجالات ليوم كامل؛ من أجل تبادل المحادثات والمناقشة حول دراسات حالة حقيقية للمشاريع والحصول على نصائح عملية من داخل كل صناعة.",
    "sec1":"لماذا تحضر مناقشات التصميم؟",
    "sec1Items":{
      "1":"تقابل مع المصممين المميزين من مختلف المجالات والمدارس والخلفيات واحصل على لمحات من التقنيات التي يعتمدون عليها.",
      "2":"تواصل من أجل الحصول على التعاون المستقبلي لمشروعك وكون صداقات من نفس مجتمعك حيث يتشابه معك في الفكر والاهتمامات.",
      "3":"تعرف على البيانات على أرض الواقع واحصل على نظرة خاطفة حول ما يحدث  في الكواليس وكيف نفكر في كل عملية تصميم تواجهنا."
    },
    "sec2":"الإبداع لم يعد لغزًا!",
    "sec2Items":{
      "1":{
        "title":"الهوية التجارية",
        "desc":"من الإستراتيجية إلى تطوير الهوية التجارية، نتشارك معكم التفاصيل الدقيقة والمهارات التي نعمل عليها داخليًا."
      },
      "2":{
        "title":"تجربة المستخدم",
        "desc":"نقدم النصائح المختلفة من أجل الحصول على تجربة مستخدم سهلة، كما أننا نناقش الموضوعات النادرة التي واجهناها طوال فترة عملنا."
      },
      "3":{
        "title":"الإنتاج ثلاثي الأبعاد",
        "desc":"سواء في تصميم المنتج أو الإعلان أو الرسوم المتحركة، نتعمق معك في الفن ثلاثي الأبعاد."
      },
      "4":{
        "title":"الإعلان",
        "desc":"بداية من إنشاء الحملة إلى معرفة سلوك المستخدم، نقدم لك الرؤى الخاصة بنا في رحلتنا في عالم الإعلان."
      }
    },
    "cta":"إنضم إلينا في<br> مناقشات التصميم!"
  }
}
</i18n>
